module.exports = __webpack_public_path__ + "img/contacto-cel.7cb9d449.png";